
import { Component, Vue } from "vue-property-decorator";
import store from "@/store";

@Component
export default class Logout extends Vue {
  private async mounted() {
    try {
      const response = await store.dispatch("auth/logout");
      const lang = store.getters["auth/lang"];
      if (response) {
        const loginPath = lang === "ja" ? "/login" : `/${lang}/login`;
        this.$router.replace(loginPath);
      } else {
        const topPath = lang === "ja" ? "/" : `/${lang}`;
        this.$router.replace(topPath);
      }
    } catch (e) {
      console.error(e);
      const err = e as { status?: number };
      this.$router.replace({
        path: "/error",
        query: { status: String(err.status != null ? err.status : 500) },
      });
    }
  }
}
